module.exports = __webpack_public_path__ + "img/Republic Day.68e8f497.jpeg";